<div class="left-navigation homeScrollmenu relative">

  <nav class="sidelist sticky-left-nav top-menu d-flex my-auto">

    <ul class="stick-left-nav-ul my-auto">

      <li class="d-flex" (click)="moveToCapabilitiesElement()">
        <span class="default" [ngClass]="{'active-border': currentActive == 1}">
          <a [ngClass]="{'active': currentActive == 1}">
            <span class="d-block ps-1 pt-1">{{capabilitiesMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToOperatingElement()">
        <span class="default" [ngClass]="{'active-border': currentActive == 2}">
          <a [ngClass]="{'active': currentActive == 2}">
            <span class="d-block ps-1 pt-1">{{OperatingMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToTransformationElement()">
        <span class="default" [ngClass]="{'active-border': currentActive == 3}">
          <a [ngClass]="{'active': currentActive == 3}">
            <span class="d-block ps-1 pt-1">{{transformationMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToNextElement()">
        <span class="default" [ngClass]="{'active-border': currentActive == 4}">
          <a [ngClass]="{'active': currentActive == 4}">
            <span class="d-block ps-1 pt-2">{{nextMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToServiceElement()">
        <span class="default" [ngClass]="{'active-border': currentActive == 9}">
          <a [ngClass]="{'active': currentActive == 9}">
            <span class="d-block ps-1 pt-2">{{serviceMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToAboutElement()">
        <span class="default" [ngClass]="{'active-border1': currentActive == 5}">
          <a [ngClass]="{'active1': currentActive == 5}">
            <span class="d-block ps-1 pt-1">{{AboutMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToSpSoftElement()">
        <span class="default" [ngClass]="{'active-border1': currentActive == 6}">
          <a [ngClass]="{'active1': currentActive == 6}">
            <span class="d-block ps-1 pt-2">{{spSoftMenu}}</span>
          </a>
        </span>
      </li>

      <li class="d-flex" (click)="moveToCareersElement()">
        <span class="default" [ngClass]="{'active-border1': currentActive == 7}">
          <a [ngClass]="{'active1': currentActive == 7}">
            <span class="d-block ps-1 pt-2">{{CareersMenu}}</span>
          </a>
        </span>
      </li>

    </ul>

  </nav>

</div>

<div class="f_name" #capabilities>
  <div id="section1" class="container-fluid section mainSection m-0 p-0">
    <!-- <div class="">
      <h2 class="text-center pt-5">your Digital transformation partner</h2>
      <p class="text-center">End to End Solutions for all kind of business applications...</p>
      <div class="d-flex justify-content-center mt-4">
        <a [routerLink]="['/capabilities']" class="customBtn text-decoration-none" role="button">Explore our capabilities...</a>
      </div>
    </div> -->
    <div>
      <video [muted]="true" autoplay="0" playsinline="" src="../../assets/images/home.mp4"
        style="min-height: 100vh;width: 100%;"></video>
      <div class="mainTitletransform w-100 mx-auto">
        <h2 class="text-center pt-5">your Digital transformation partner</h2>
        <p class="text-center">End to End Solutions for all kinds of business applications...</p>
        <div class="d-flex justify-content-center mt-4">
          <a [routerLink]="['/capabilities']" class="customBtn text-decoration-none text-uppercase"
            role="button">Explore our core capabilities...</a>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="first_section pt-1" #Operating>
  <div id="section2" class="container d-flex align-items-center section">

    <div class="custom-container py-5">

      <div class="py-5">

        <div class="row" data-aos="fade-up" data-aos-duration="800">
          <div class="col-lg-8">
            <h2 class="text-uppercase m-0 lineHeight">our core capabilities for your digital outcomes</h2>
            <p class="m-0 py-3 text-white">We offer varied services like Software Development, Data Analytics, AI
              Solutions, Cloud-based Application
              Development, Manufacturing Automation Development, Mobile Application Development and Telecom Testing
              Services.</p>
            <div class="d-flex justify-content-start py-4">
              <a [routerLink]="['/capabilities']" class="customBtn text-decoration-none text-uppercase"
                role="button">Explore our core capabilities...</a>
            </div>
          </div>
        </div>

        <div class="row caseStudy" data-aos="fade-right" data-aos-duration="800">
          <h6 class="text-uppercase text-white m-0 py-4 fontnormal tiTle">case studies</h6>
          <div class="col-lg-4 businessPayment">
            <h4> Business Payments <br /> Ecosystem Made Simple</h4>
            <p class="fontnormal">- Banking & Financial </p>
            <a href="#" [routerLink]="['/expertise']" class="text-decoration-none" role="button">View</a>
          </div>
          <div class="col-lg-4 businessPayment">
            <h4> Location-Based Services <br /> Enterprise Mobile App </h4>
            <p class="fontnormal">- Retail </p>
            <a href="#" [routerLink]="['/expertise']" class="text-decoration-none" role="button">View</a>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>

<div class="second_section" #transformation>
  <div id="section3" class="container d-flex align-items-center section">

    <div class="custom-container py-5">

      <div class="row d-flex align-items-center py-5">

        <div class="col-lg-5">
          <img class="img-fluid p-4" src="../../assets/images/operatingDigitalModel.png" alt="operatingDigitalModel">
        </div>

        <div class="col-lg-7">
          <div data-aos="fade-up" data-aos-duration="800">
            <h2 class="text-uppercase m-0 lineHeight">our digital operating models</h2>
            <p class="m-0 py-3  text-white">Adopt accelerators to evolve your way of working.</p>
            <div class="d-flex justify-content-start py-4">
              <a href="#" [routerLink]="['/capabilities']" class="customBtn text-decoration-none text-uppercase"
                role="button">Explore our core capabilities...</a>
            </div>
          </div>
          <div class="caseStudy" data-aos="fade-up" data-aos-duration="800">
            <h6 class="text-uppercase text-white m-0 py-4 fontnormal">case studies</h6>
            <div class="row">
              <div class="col-lg-6">

                <h4 class="fourthDesc">
                  Digital Vehicle <br />Inspection
                </h4>
                <p class="caseTitle">- Transport</p>
                <a href="#" [routerLink]="['/expertise']" class="text-decoration-none" role="button">View</a>
              </div>
              <div class="col-lg-6">


                <h4 class="fourthDesc">
                  Sportsbook, Casino, Racebook and Slot Games
                </h4>
                <p class="caseTitle">- Gaming</p>
                <a href="#" [routerLink]="['/expertise']" class="text-decoration-none" role="button">View</a>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>

<div class="third_section" #next>
  <div id="section4" class="container section d-flex justify-content-center">
    <div class="custom-container py-5 my-auto">
      <div class="row py-5">

        <div class="col-lg-5 my-auto">
          <div data-aos="fade-right" data-aos-duration="900">
            <h6 class="text-uppercase text-white m-0 lineHeight pb-3">Industries <br />we support</h6>
            <h2 class="text-uppercase m-0 py-3  pb-4" style="font-weight: 400"><span class="fontnormal">we support
              </span>100<span class="verticalPlus">+</span>
              global clients.
              over 6<span class="verticalPlus">+ </span>countries<span class="fontnormal"> from
                all the sectors.</span></h2>

            <div class="d-flex justify-content-start pt-4">
              <a href="#" [routerLink]="['/banking-service']"
                class="customBtn text-decoration-none text-white px-5 text-uppercase" role="button">Explore
                More...</a>
            </div>
          </div>
        </div>


        <div class="col-lg-7">
          <img class="img-fluid p-3" data-aos="fade-up" data-aos-duration="900" src="../../assets/images/wesupport.png"
            alt="weSupport">
        </div>

      </div>
    </div>
  </div>
</div>




<div class="eight_section" #service>
  <div id="section9" class="d-flex align-items-center serviceApproch">
    <div class="container py-5">
      <div class="custom-container py-5">

        <div class="row ">
          <h3 class="text-center text-white">
            OUR DIGITAL ENABLED SERVICE OFFERINGS
          </h3>
          <p class="subTitle m-0 text-center">With SPSoft’s Managed Services, you can outsource critical functions to
            a team of<br>experts who specialise in areas such as</p>
        </div>
        <div class="row servicesGrid pt-lg-5 pt-md-5 pt-4" data-aos="fade-up" data-aos-duration="800">
          <div class="col-lg-3 col-md-6 px-3 mb-4" [routerLink]="['/data-analytics-services']" style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/DataServiceGrid.svg" alt="">
            <p class="m-0 mainTitle">Data Analytics</p>
            <p class="m-0 subTitle">
              Transform your business with our AI and ML Services... Read More
            </p>

          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4" [routerLink]="['/ai-ml-services']" style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/AiMl.svg" alt="">
            <p class="m-0 mainTitle">AI & ML</p>
            <p class="m-0 subTitle">
              Invest in next-gen technology to upscale your... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4" [routerLink]="['/mobile-app-development-services']" style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/MobileAppsDevelopment.svg" alt="">
            <p class="m-0 mainTitle">Mobile Apps Development </p>
            <p class="m-0 subTitle">
              Crafting feature-packed native mobile application... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4" [routerLink]="['/application-development-maintenance-services']"
            style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/AppDevelopment.svg" alt="">
            <p class="m-0 mainTitle">Application Development</p>
            <p class="m-0 subTitle">
              Our development service empowers... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4 mb-lg-0 mb-md-4" [routerLink]="['/web-development-services']"
            style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/WebDevelopment.svg" alt="">
            <p class="m-0 mainTitle">Web Development</p>
            <p class="m-0 subTitle">
              Web development services that meet diverse... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4 mb-lg-0 mb-md-4" [routerLink]="['/testing-services']"
            style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/TestingDevelopment.svg" alt="">
            <p class="m-0 mainTitle">Testing</p>
            <p class="m-0 subTitle">
              We perform comprehensive testing and quality assurance... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-4 mb-lg-0 mb-md-4" [routerLink]="['/digital-marketing-services']"
            style="cursor: pointer;">

            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/SeoAndDigitalMarketing.svg" alt="">
            <p class="m-0 mainTitle">SEO & Digital Marketing </p>
            <p class="m-0 subTitle">
              SEO ensures that your business gets the mos... Read More
            </p>
          </div>

          <div class="col-lg-3 col-md-6 px-3 mb-0 mb-lg-0 mb-md-4" [routerLink]="['/workforcesolutions']"
            style="cursor: pointer;">


            <img class="py-2 img-fluid w-100" src="../../assets/images/offshore/WorkForce.svg" alt="">
            <p class="m-0 mainTitle">Workforce</p>
            <p class="m-0 subTitle">
              Hiring Quality Talent, We're enablers to make... Read More
            </p>
          </div>
        </div>


      </div>

    </div>
  </div>

</div>







<div class="fourth_section pt-1" #About>
  <div id="section5" class="container d-flex align-items-center section">
    <div class="custom-container py-5">

      <div class="row caseStudy py-5">
        <h2 class="text-uppercase  m-0 pb-3 lineHeight text-white">empowering talent transformation <br />for digital
          feature</h2>
        <p>We develop talent for digital future</p>
        <h6 class="text-uppercase m-0 py-4 insIghts text-white">Insights</h6>

        <div class="col-lg-4 pb-2" data-aos="zoom-in-up" data-aos-duration="800">
          <img class="img-fluid" src="../../assets/images/empoweringItStaffing.jpg" alt="empoweringItStaffing">
          <h4 class="pt-3 fourthDesc text-white">
            We have become one of the premier IT Staffing Companies in India within a decade.
            Solutions
          </h4>
          <p class="caseTitle">- Workforce Solutions</p>
          <a href="#" [routerLink]="['/workforcesolutions']" class="text-decoration-none" role="button">View</a>
        </div>

        <div class="col-lg-4 pb-2" data-aos="zoom-in-up" data-aos-duration="800">
          <img class="img-fluid" src="../../assets/images/empoweringDigitalWorkforce.jpg"
            alt="empoweringDigitalWorkforce">
          <h4 class="pt-3 fourthDesc text-white">
            Improving Productivity for Digital Workforce
          </h4>
          <p class="caseTitle">- Empowering Talent</p>
          <a href="#" [routerLink]="['/workforcesolutions']" class="text-decoration-none" role="button">View</a>
        </div>

      </div>

    </div>

  </div>
</div>

<div class="fifth_section" #spsoft>
  <div id="section6" class="section">
    <div class="fifthGrid py-5">
      <div class="container">
        <div class="custom-container">
          <div class="row justify-content-start">
            <div class="col-lg-12 text-center" data-aos="fade-up" data-aos-duration="800">
              <h2 class="text-uppercase m-0 py-3 pt-4 text-white">why spsoft?</h2>
              <p class="m-0 spsoftContent">SPSoft designs and deploys digital solutions for our clients at scale to
                modernize the way they use <br />technology to deliver better business outcomes.</p>
            </div>
          </div>
          <div class="row justify-content-center py-5 my-5 spsoFtCount mx-auto">

            <div class="col-md-2 px-1">
              <div class="counter-box mx-auto colored d-block">
                <p class="counter text-center m-0">{{projectCount}}<span>+</span></p>
                <p class="text-center m-0 spsoftDesc">Years of Experience</p>
              </div>
            </div>

            <div class="col-md-2 px-1">
              <div class="counter-box mx-auto colored d-block">
                <p class="counter text-center m-0">{{accurateCount}}<span>+</span></p>
                <p class="text-center m-0 spsoftDesc">Global Clients</p>
              </div>
            </div>

            <div class="col-md-2 px-1">
              <div class="counter-box mx-auto colored d-block">
                <p class="counter text-center m-0">{{clientCount}}<span>+</span></p>
                <p class="text-center m-0 spsoftDesc">Projects</p>
              </div>
            </div>

            <div class="col-md-2 px-1">
              <div class="counter-box mx-auto colored d-block">
                <p class="counter text-center m-0">{{customerFeedback}}<span>+</span></p>
                <p class="text-center m-0 spsoftDesc">Expert Developers</p>
              </div>
            </div>

            <div class="col-md-2 px-1">
              <div class="counter-box mx-auto colored d-block">
                <p class="counter text-center m-0">{{countries}}<span>+</span></p>
                <p class="text-center m-0 spsoftDesc">Countries</p>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="container-fluid whySpsoft">
        <div class="row py-5">
          <div class="col-lg-6 px-0" data-aos="fade-right" data-aos-duration="900">
            <img class="img-fluid" src="../../assets/images/whyspsoft.png" alt="whySpsoft">

          </div>
          <div class="col-lg-6 px-4 flexiBilityList overflow-hidden">
            <div class="detailList w-75">
              <div data-aos="fade-left" data-aos-duration="1000">
                <p class="m-0 text-uppercase">flexibility</p>
                <h6 class="py-2 text-white">Flexibility to adopt requirements and <br /> allocate work efficiently</h6>
              </div>
            </div>

            <div class="detailList w-75">
              <div data-aos="fade-left" data-aos-duration="1200">
                <p class="m-0 text-uppercase pt-3">collaboration</p>
                <h6 class="py-2 text-white">Timely collaboration to import <br /> performance outcomes</h6>
              </div>
            </div>

            <div class="detailList w-75">
              <div data-aos="fade-left" data-aos-duration="1400">
                <p class="m-0 text-uppercase pt-3">visibility</p>
                <h6 class="py-2 text-white">Visibility into delivery activity, proactive <br /> alerts and key metrics
                </h6>
              </div>
            </div>


            <div class="detailList w-75 border-0">
              <div data-aos="fade-left" data-aos-duration="1600">
                <p class="m-0 text-uppercase pt-3">Insight</p>
                <h6 class="py-2 text-white">Deeper insight to drive business outcomes</h6>
              </div>
            </div>


            <div class="d-flex justify-content-start py-4" data-aos="fade-left" data-aos-duration="1800">
              <a href="#" [routerLink]="['/about-us']" class="customBtn text-decoration-none text-uppercase px-5"
                role="button">Explore More...</a>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="overallClients py-5">

      <div class="container">

        <div class="custom-container">

          <div class="row clientGridimages mb-3 py-5 mx-auto">
            <h2 class="text-uppercase text-center text-white m-0 mb-4 pb-5" data-aos="fade-up" data-aos-duration="1800">
              our growth enablers</h2>

            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/rockwell.svg" alt="rockwell">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/premierAmerica.svg" alt="premierAmerica">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/qualcomm.svg" alt="qualcomm">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/mulesoftLogo.svg" alt="mulesoft">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/init.svg" alt="init">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/codebase.svg" alt="codebase">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/oracle.svg" alt="oracle">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/paramount.svg" alt="paramount">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/citadel.svg" alt="citadel">

            </div>
            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/apaylo.svg" alt="apaylo">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/siliconLabs.svg" alt="siliconLabs">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/JHON.svg" alt="jhonDeere">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/INSIGHT.svg" alt="insight">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0">
              <img class="img-fluid" src="../../assets/images/clients/dristia.svg" alt="dristia">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>
            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/superPicks.svg" alt="superPicks">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0" data-aos="fade-down" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/sportbet.svg" alt="sportbetting">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>

            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/telsu.svg" alt="telus">
            </div>

            <div class="clientsImg px-0 clientsEmpty"> </div>
            <div class="clientsImg px-0" data-aos="fade-up" data-aos-duration="1800">
              <img class="img-fluid" src="../../assets/images/clients/win4real.svg" alt="win4real">
            </div>

            <h6 class="text-center m-0 termConditions pt-5 lh-base">
              All company, product and service names of the third party companies used in this website are for
              identification purposes only. All these product names, logos and brands belong to their respective owners.
            </h6>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

<div class="sixth_section" #Careers>
  <div id="section7" class="section d-flex justify-content-center">
    <div class="my-auto justify-content-center">
      <app-careers></app-careers>
    </div>
  </div>
</div>

<div class="seventh_section" #Contact>
  <div id="section8" class="container">
    <!-- <app-contact-us></app-contact-us> -->
  </div>
</div>

<a data-bs-toggle="modal" class="pointer d-none" data-bs-target="#boardmemeber124" #DefaultHomeModalTrigger>
  Disclaimer</a>


<div class="years justify-content-end position-fixed">
  <a><img class="img-fluid pb-1" src="../../assets/images/26yearsJourney.svg" alt="spsoft"></a>
</div>

<div class="modal fade" id="boardmemeber124" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">

  <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" role="document">

    <div class="modal-content">

      <div class="modal-body" style="border-bottom: 8px solid #39f;">

        <button type="button" class="btn-close pr-2 close" id="DefaultHomeDisclaimerModal" #DefaultHomeDisclaimerModal
          data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="row p-3 discontent">

          <div class="col-lg-24 text-center">

            <!-- <div class="board-semhead font-weight-bold">DISCLAIMER</div>
            <hr class="discclaiBdr"> -->


            <div class="board-semhead font-weight-bold">

              <h4 class="m-0 pb-2">DISCLAIMER</h4>
              <hr class="discclaiBdr mb-1">

            </div>

            <p class="member-designation-content mb-2">
              We bring to the notice of all concerned that we, i.e., SP Software (P) Limited, have deployed a
              merit-based employee selection practice. We do not charge or accept any amount or security deposit from
              job seekers during the selection process or while inviting candidates for an interview. Any party posing
              on behalf of SP Software (P) Limited and collecting money from candidates, promising them jobs is doing so
              with fraudulent intent and wrongfully using the company name.
            </p>
            <p>
              In case you are demanded money for a job by an SP Software (P) Limited employee, affiliated party, or
              consultant, please bring it to our notice by writing to
            </p>

            <a href="mailto:info@spsoftglobal.com">info@spsoftglobal.com</a>


          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div [innerHTML]="localBusinessDataHTML"></div>
<div [innerHTML]="logoDataHTML"></div>
<div [innerHTML]="breadCrumbDataHTML"></div>